import { AirtableHomepageItem } from "../../models/airtable";

export function formatHeroImage(
    item: AirtableHomepageItem | undefined,
    isWebDesktopScreen: boolean,
  ) {
    const image = isWebDesktopScreen ? item?.heroImageWeb : item?.heroImage;
  
    return {
      uri: image?.url || '',
    };
  }